import { render, staticRenderFns } from "./DetailsOrder.vue?vue&type=template&id=34bbcd72&scoped=true&"
import script from "./DetailsOrder.vue?vue&type=script&lang=js&"
export * from "./DetailsOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailsOrder.vue?vue&type=style&index=0&id=34bbcd72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bbcd72",
  null
  
)

export default component.exports